import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./pressure.css";

import { Link } from "react-router-dom";
export default function ControleCablesView() {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,
    pauseOnHover: false,
  };

  return (
    <>
      <Header />

      <main className="prs">
        {/* ===== HERO ===== */}
        <section className="prs-hero">
          <div className="prs-hero__text">
            <h1>Contrôle des Câbles de Levage</h1>
            <p>
              VERATRAC SAFETY (VERATRACT-SAFETY) réalise des inspections de câbles d’acier pour
              garantir la sécurité des opérations de levage et anticiper tout risque
              de rupture. Nos méthodes combinent contrôle visuel expert et mesures
              magnétiques de haute sensibilité.
            </p>

            <div className="prs-hero__bullets">
              <span>🧲 Mesure magnétique rémanente (faible champ)</span>
              <span>🔎 Détection interne & surface</span>
              <span>📈 Rapport quantifié (perte de section)</span>
            </div>

            <a href="#contact" className="btn-primary">Demander une inspection</a>
          </div>

          <div className="prs-hero__slider">
            <Slider {...sliderSettings}>
              <div><img src="/images/Cable/1.jpg" alt="Inspection de câble sur treuil" /></div>
              <div><img src="/images/Cable/2.jpg" alt="Mesure magnétique rémanente" /></div>
              <div><img src="/images/Cable/3.jpg" alt="Contrôle visuel et jauge" /></div>
              <div><img src="/images/Cable/4.jpg" alt="Câble de levage en service" /></div>
            </Slider>
          </div>
        </section>

        {/* ===== CONTENU TECHNIQUE ===== */}
        <section className="prs-reglement prs-simple">
          <h2>Pourquoi contrôler les câbles ?</h2>
          <p>
            Un câble de levage vieillit sous l’effet de l’usure, de la corrosion,
            des chocs et des cycles de charge. Certaines dégradations sont visibles,
            d’autres restent internes et <strong>indétectables à l’œil nu</strong>.
            Un suivi régulier évite les ruptures, protège les personnes et limite
            les arrêts imprévus.
          </p>

          <h3>Familles de défauts surveillées</h3>
          <ul>
            <li><strong>Perte de section</strong> (usure, corrosion, abrasion).</li>
            <li><strong>Ruptures de fils</strong> (externes et internes).</li>
            <li><strong>Déformations</strong> : cage d’oiseau, écrasement, coque, torsion.</li>
            <li><strong>Fatigue</strong> due aux cycles et aux vibrations.</li>
          </ul>

          <h3>Méthodes de contrôle : comparaison</h3>
          <ul>
            <li>
              <strong>Ancienne approche “champ fort”</strong> (Hall) : détection des fuites
              de champ sur câble saturé. <em>Limites :</em> faible sensibilité aux défauts
              internes, signal bruyant et dépendant de la vitesse, têtes lourdes.
            </li>
            <li>
              <strong>Méthode à faible champ magnétique</strong> (rémanence – celle que nous utilisons) :
              mesure du <em>champ rémanent vectoriel</em> après magnétisation. Très stable,
              détecte efficacement les défauts internes et fournit une estimation
              <strong>quantifiée</strong> de la perte de section.
            </li>
          </ul>

          <h3>Capteurs & principe</h3>
          <p>
            Nous utilisons des capteurs de dernière génération (type “Duo Element”),
            bien plus sensibles que les anciens éléments Hall. L’analyse vectorielle
            de la rémanence distingue clairement une section saine d’une section
            affectée (fils rompus, corrosion interne, etc.).
          </p>

          <h3>Appareillage utilisé</h3>
          <ul>
            <li>Aimant permanent compact (&lt; 2 kg).</li>
            <li>Tête de mesure multi-capteurs (~1,5 kg) pour relevés haute résolution.</li>
            <li>Logiciel de traitement et classification des défauts.</li>
          </ul>

          <h3>Atouts de la méthode faible champ</h3>
          <ul>
            <li>Détecte les défauts <strong>au cœur du câble</strong> (fils internes).</li>
            <li>Peu sensible aux variations de vitesse d’enroulement.</li>
            <li>Résultats exprimés en <strong>équivalent perte de section</strong>.</li>
            <li>Statistiques automatiques : léger / moyen / sérieux / sévère.</li>
            <li>Signal filtré pour une <strong>interprétation claire</strong>.</li>
            <li>Étalonnage intelligent et matériel <strong>léger</strong> pour travaux en hauteur.</li>
          </ul>

          <h3>Étapes d’une inspection type</h3>
          <ul>
            <li>Magnétisation contrôlée du câble.</li>
            <li>Balayage en service ou hors service selon accessibilité.</li>
            <li>Traitement des signaux et cartographie des anomalies.</li>
            <li>Rapport avec localisation, classification et recommandations.</li>
          </ul>

          <h3>Formation & normes</h3>
          <p>
            VERATRACT-SAFETY organise des formations à l’inspection des câbles et à l’exploitation
            des normes applicables (levage/levage portuaire, équipements de manutention).
            Nos procédures s’alignent sur les bonnes pratiques internationales
            et les exigences réglementaires nationales.
          </p>

          <div className="prs-btns">
            <Link to="/#contact" className="btn-primary">faire une consultation</Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
